import { Manager } from "socket.io-client";
import { getClientRef } from "../../app/modules/localstorage";
import { env } from "../../config/env";

// Check if we're in a test environment or if server URL is unavailable
const isTestEnvironment = 
  env.NODE_ENV === 'test' || 
  typeof window !== 'undefined' && window.location.href.includes('listing-test') ||
  !env.SERVER_URL ||
  env.SERVER_URL.includes('ngrok-free.app');

let manager: Manager | null = null;
let socket: any = null;

if (!isTestEnvironment) {
  const clientRef = getClientRef();
  const clientId = clientRef?.id ?? "";

  manager = new Manager(env.SERVER_URL, {
    transports: ["websocket"],
    autoConnect: true,
    // reconnectionAttempts: 10,
    reconnectionDelay: 3000,
    reconnectionDelayMax: 5000,
    timeout: 20000,
    query: {
      clientId: clientId,
    },
  });

  console.log("SOCKET INITED");
  socket = manager.socket(`/`);
} else {
  console.log("SOCKET DISABLED - Test environment or invalid server URL detected");
  
  // Create a mock socket object for test environments
  socket = {
    on: () => {},
    emit: () => {},
    off: () => {},
    disconnect: () => {},
    connect: () => {},
    connected: false,
    id: 'mock-socket-id'
  };
}

const SocketConnection = () => {
  return socket;
};

export default SocketConnection;
